export default {
  UFO: "UFO",
  SHIPWRECK: "SHIPWRECK",
  PLANECRASH: "PLANECRASH"
};



// WEBPACK FOOTER //
// ./src/utils/observation_types.js